import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import ConfigurationForm from './ConfigurationForm';
import PropTypes from 'prop-types';
import api from 'api';

class ConfigurationCopyButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      updating: false,
      errors: {}
    }

    this.configurationForm = React.createRef();
  }

  configurationCreate(e, data) {
    e.preventDefault();
    this.setState({creating: true});

    api.configuration.post.configuration({
      data: data.configuration
    }).then(() => {
      this.props.handleChange();
      this.setState({
        creating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        creating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { updating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="lg">
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="admin.configurationCopyButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <ConfigurationForm errors={errors} onSubmit={this.configurationCreate} ref={this.configurationForm} configuration={this.props.configuration}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={updating}
            data-style={ZOOM_OUT}
            onClick={e => this.configurationCreate(e, this.configurationForm.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <span className="fas fa-clone mr-2 pointer" onClick={() => this.toggleModal()}/>
        {modal}
      </React.Fragment>
    )
  }
}

ConfigurationCopyButton.propTypes = {
  configuration: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null, null , null, {forwardRef: true})(ConfigurationCopyButton);